(function () {
  "use strict";

  const callback = () => {
    const calendlyContainer = document.querySelectorAll("button[data-calendly-url]");
    calendlyContainer.forEach((item) => {
      item.addEventListener("click", () => {
        Calendly.initPopupWidget({
          url: item.dataset.calendlyUrl,
          parentElement: item,
          prefill: {},
          utm: {},
        });
      });
    });
  };

  // We attach the callback to the DOM ready, and to the shopify:section:load. This way this section
  // will (re)initialise when adjusting configuration in the Shopify theme editor.
  window.addEventListener("DOMContentLoaded", callback);
  window.addEventListener("shopify:section:load", callback);
})();
